import { Report194Container } from "../../../containers/borrowSystem/Report/Report194Container";

export function Report194Page() {
    return (
        <Report194Container />
    )
}